// extracted by mini-css-extract-plugin
export default {"stepsCounter":"StepsCounter-module--stepsCounter--DRCNx","whiteCounter":"StepsCounter-module--whiteCounter--EgRPL"};